import {Button, Card, CardBody, CardHeader, Input, Typography,} from "@material-tailwind/react";
import React, {useEffect, useState} from "react";
import {BranchDiscountGrid} from "./grid";
import {BranchDiscountForm} from "./form";
import {getBranchDiscounts} from "../../services/branch_discount/branch_discount";
import {CardFooterPaginator} from "../system/cardFooterPaginator";
import SelectInput from "../system/select";
import {getFields} from "../../services/field/field";
import {getFieldBranchesByFieldId} from "../../services/branch/branch";
import DateField from "../system/dateField";
import {PaginateContext} from "../../context/paginate";

export function BranchDiscountManagement() {

  const [branchDiscounts, setBranchDiscounts] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [gridRowCount, setGridRowCount] = useState(0);
  const [gridCurrentPage, setGridCurrentPage] = useState(1);
  const [gridSelectedRow, setGridSelectedRow] = useState(null);
  const [gridTotalRowCount, setGridTotalRowCount] = useState(0);
  const [sortBy, setSortBy] = useState("id")
  const [sortType, setSortType] = useState(false);
  const [from, setFrom] = useState((gridCurrentPage - 1) * gridRowCount + 1);
  const [to, setTo] = useState((gridCurrentPage) * gridRowCount);
  const [lastDataRefresh, setLastDataRefresh] = useState(null);

  const [fieldId, setFieldId] = useState(null);
  const [branchId, setBranchId] = useState(null);
  const [status, setStatus] = useState(null);
  const [serviceType, setServiceType] = useState(null);
  const [discountCode, setDiscountCode] = useState(null);
  const [percentage, setPercentage] = useState(null);
  const [expirationDate, setExpirationDate] = useState(null);


  useEffect(() => {
    if ((gridCurrentPage) * gridRowCount <= gridTotalRowCount) {
      setTo((gridCurrentPage) * gridRowCount)
    } else {
      setTo(gridTotalRowCount)
    }
    if (gridTotalRowCount === 0) {
      setFrom(0)
    } else {
      setFrom((gridCurrentPage - 1) * gridRowCount + 1)
    }
  }, [gridCurrentPage, gridRowCount, gridTotalRowCount]);

  async function getData(paginate) {
    const result = await getBranchDiscounts(paginate);
    if (result.status === 200) {
      const {branchDiscountList, total_count} = result.data;
      setBranchDiscounts(branchDiscountList || []);
      setGridTotalRowCount(total_count);
    }
  }

  useEffect(() => {
    const paginateParams = new URLSearchParams({
      "sort_by": sortBy,
      "sort_type": sortType === false ? "DESC" : "ASC",
      "limit": parseInt(gridRowCount),
      "offset": (parseInt(gridCurrentPage) - 1) * parseInt(gridRowCount),
    })

    const filterParams = new URLSearchParams({})

    if (fieldId) {
      filterParams.append("field_id", fieldId)
    }

    if (branchId) {
      filterParams.append("branch_id", branchId)
    }

    if (serviceType) {
      filterParams.append("service_type", serviceType)
    }

    if (status) {
      filterParams.append("status", status)
    }

    if (discountCode) {
      filterParams.append("discount_code", discountCode)
    }

    if (percentage) {
      filterParams.append("percentage", percentage)
    }

    if (expirationDate) {
      filterParams.append("expiration_date", expirationDate)
    }


    for (const [key, value] of filterParams.entries()) {
      paginateParams.append(key, value);
    }

    const paginate = paginateParams.toString()

    getData(paginate)
  }, [fieldId, branchId, serviceType, status, discountCode, percentage, expirationDate, lastDataRefresh, gridCurrentPage, gridRowCount, sortBy, sortType]);

  return (
    <PaginateContext.Provider value={{
      setSortBy: setSortBy,
      sortType: sortType,
      setSortType: setSortType,
      active: gridCurrentPage,
      setActive: setGridCurrentPage,
      totalRows: gridTotalRowCount,
      rowsCount: gridRowCount,
      setRowsCount: setGridRowCount,
      from: from,
      to: to,
    }}>
      <div className="">
        <BranchDiscountForm branchDiscount={gridSelectedRow} open={modalOpen} setOpen={setModalOpen}
                            setLastDataRefresh={setLastDataRefresh} setGridSelectedRow={setGridSelectedRow}
                            setBranchDiscounts={setBranchDiscounts}
        />
        <Card className="pt-8">
          <CardHeader floated={true} shadow={false} className="rounded-none">
            <div className="mb-8 flex items-center justify-between gap-8">
              <Typography variant="h5" color="blue-gray">تخفیف سرویس ها</Typography>
              <Button onClick={() => {
                setGridSelectedRow(null);
                setModalOpen(true);
              }} variant="outlined">جدید</Button>
            </div>
          </CardHeader>
          <CardBody className="overflow-x-auto w-full">

            <div className="grid grid-cols-1 gap-4 mb-8 md:grid-cols-3 xxl:grid-cols-3">

              <div className="flex flex-col">
                <SelectInput
                  label={"رشته"}
                  defaultValue={fieldId}
                  autoLoadService={getFields}
                  onChange={setFieldId}
                />
              </div>

              <div className="flex flex-col">
                <SelectInput
                  label={"گرایش"}
                  defaultValue={branchId}
                  refreshSignal={fieldId}
                  autoLoadService={getFieldBranchesByFieldId}
                  autoLoadServiceData={fieldId}
                  autoLoadRender={({title}) => {
                    return title
                  }}
                  onChange={setBranchId}
                />
              </div>

              <div className="flex flex-col">
                <SelectInput
                  label={"نوع سرویس"}
                  options={[
                    {
                      "id": 'consultation',
                      "title": "مشاوره"
                    },
                    {
                      "id": 'service',
                      "title": "خدمات"
                    },
                  ]}
                  onChange={setServiceType}
                />
              </div>

              <div className="flex flex-col">
                <SelectInput
                  label={"وضعیت"}
                  options={[
                    {
                      "id": 'enable',
                      "title": "فعال"
                    },
                    {
                      "id": 'disable',
                      "title": "غیر فعال"
                    },
                  ]}
                  onChange={setStatus}
                />
              </div>

              <div className="flex flex-col">
                <Input
                  label="کد تخفیف"
                  variant="standard"
                  onBlur={(e) => {
                    setDiscountCode(e.target.value)
                  }}
                />
              </div>

              <div className="flex flex-col">
                <Input
                  label="درصد"
                  variant="standard"
                  type="number"
                  onBlur={(e) => {
                    setPercentage(e.target.value)
                  }}
                />
              </div>

              <div className="flex flex-col">
                <DateField
                  className="my-4 mx-4 w-full"
                  date={expirationDate}
                  setDate={setExpirationDate}
                  label={"اعتبار تا"}
                />
              </div>

            </div>

            <div className="flex flex-row">
              <Button variant="gradient" color="gray" onClick={() => {
                setFieldId(null)
                setBranchId(null);
                setServiceType(null);
                setStatus(null);
                setDiscountCode(null);
                setPercentage(null);
                setExpirationDate(null);
              }} className="ml-1">
                <span>حذف فیلتر</span>
              </Button>
            </div>

            <BranchDiscountGrid
              BranchDiscounts={branchDiscounts}
              setModalOpen={setModalOpen}
              setSelectedRow={setGridSelectedRow}
            />
          </CardBody>
          <CardFooterPaginator/>
        </Card>
      </div>
    </PaginateContext.Provider>
  )
    ;
}